export const GET_PROGRAM_PROFILE = "GET_PROGRAM_PROFILE";
export const RESET_PROGRAM_PROFILE = "RESET_PROGRAM_PROFILE";
export const PROGRAM_PROFILE_LOADING_STATE = "PROGRAM_PROFILE_LOADING_STATE";
export const START_LOADING_PROGRAM = "START_LOADING_PROGRAM";
export const ERROR_LOADING_PROGRAM = "ERROR_LOADING_PROGRAM";
export const STOP_LOADING_PROGRAM = "STOP_LOADING_PROGRAM";
